module.exports = __webpack_public_path__ + "img/1f3d6.d9d38b6.svg";